module.exports = __webpack_public_path__ + "097e8302.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_tag/Column/bg_03.jpg
// module id = 1263
// module chunks = 2